/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Model_Usage_DescriptionInputs */



/**
* | output |
* | --- |
* | "Visual breakdown of requests by AI model" |
*
* @param {Dashboard_Model_Usage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_usage_description = /** @type {((inputs?: Dashboard_Model_Usage_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Usage_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Visuelle Aufschlüsselung der Anfragen nach KI-Modell")
	return /** @type {LocalizedString} */ ("Visual breakdown of requests by AI model")
});